import { t } from "i18next";
import { useState } from "react";

import { Button } from "@/components/Button";
import NFTMedia from "@/components/NFTMedia";
import { NFTPurchasedParams } from "@/interfaces/modals";

import styles from "./styles";
import { SheetModal } from "../index";
import { SheetDescription, SheetTitle } from "../styles";

export const useNFTPurchasedModal = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [nft, setNFT] = useState<NFTPurchasedParams>(null);

  const openModal = (data: NFTPurchasedParams) => {
    setNFT(data);
    setOpen(true);
  };

  const closeModal = () => {
    setNFT(null);
    setOpen(false);
  };

  const modal = nft ? (
    <SheetModal isOpen={isOpen} closeModal={closeModal} detent="content-height">
      <styles.Container>
        <styles.Header>
          <SheetTitle>{t("Modals.NFT.Congratulations")}</SheetTitle>
          <SheetDescription>{t("Modals.NFT.NFTTokenID", { tokenId: nft.tokenId })}</SheetDescription>
        </styles.Header>
        <styles.NFT>
          <NFTMedia media={nft.url} />
        </styles.NFT>
        <Button type="black" name={"Ok"} handler={closeModal} />
      </styles.Container>
    </SheetModal>
  ) : (
    <></>
  );

  return { isOpen, openModal, closeModal, modal };
};
